import { useParams } from 'react-router-dom';
import { useClientAuth } from '../context/ClientAuthContext';
import { SellerPortalPanels, useSellerPortalData } from '../components/clientPortal/SellerPortalPanels';
import './ClientPortal.css';

export default function ClientSellingPage() {
  const { slug } = useParams();
  const { client, reload } = useClientAuth();
  const sellerData = useSellerPortalData(slug, client, reload);

  return (
    <div className="client-portal-page">
      <header className="client-portal-page__header">
        <h1>Selling your home</h1>
        <p>Synced from your conversations with {client.agent?.assistant_name || 'Ava'}.</p>
      </header>
      <SellerPortalPanels
        client={client}
        slug={slug}
        consultations={sellerData.consultations}
        syncing={sellerData.syncing}
        syncMsg={sellerData.syncMsg}
        onSyncFromChat={sellerData.handleSyncFromChat}
        profile={sellerData.profile}
        saving={sellerData.saving}
        saveMsg={sellerData.saveMsg}
        onChange={sellerData.handleChange}
        onSave={sellerData.handleSave}
        consultationsError={sellerData.consultationsError}
      />
    </div>
  );
}
